// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeleteMasterInvoiceMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteMasterInvoiceMutationResult = { __typename?: 'Mutation', deleteMasterInvoice: boolean };

export const DeleteMasterInvoiceGql = gql`
    mutation DeleteMasterInvoice($id: Int!) {
  deleteMasterInvoice(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMasterInvoiceInjectable extends Apollo.Mutation<DeleteMasterInvoiceMutationResult, DeleteMasterInvoiceMutationVariables> {
    override document = DeleteMasterInvoiceGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */